import React, { Component, Fragment } from 'react';
import Sidebar from "../navigation/Sidebar";
import Splinechart from "../charts/Splinechart";
import Card from "../servers/Card";
import { Link } from 'react-router-dom';
class SimDetail extends Component {
    render() {
        return (
            <Fragment>
                <div className="wrapper">
                    <Sidebar logout={() => this.props.callBackLogout()}  />
                    <div id="content">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="">
                                        <h4 className="mb-center">Detalle del sim</h4>
                                        <div className="detalle-servidor-wrapper container">
                                            <div className="row">
                                                <div className="detalle-servidor-sidebar col-md-3">
                                                    <ul className="list-unstyled">
                                                        <li>
                                                            <p>
                                                                <strong>Nombre del servidor</strong>
                                                            </p>
                                                            <p>Server tk</p>
                                                        </li>
                                                        <li>
                                                            <p>
                                                                <strong>Mensajes enviados</strong>
                                                            </p>
                                                            <p>345</p>
                                                        </li>
                                                        <li>
                                                            <p>
                                                                <strong>Mensajes recibidos</strong>
                                                            </p>
                                                            <p>1,125</p>
                                                        </li>
                                                        <li>
                                                            <p>
                                                                <strong>Estatus de SIM</strong>
                                                            </p>
                                                            <p>
                                                                <i className="fas fa-circle text-success"></i> En línea
                                                            </p>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="detalle-servidor-content col-md-9">

                                                    <div className="detalle-servidor-dash">
                                                        <Splinechart />
                                                    </div>
                                                    <div className="detalle-servidor-pie">
                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                <Card
                                                                    titulo="ENVIADOS"
                                                                    total="3,200" />
                                                            </div>
                                                            <div className="col-md-3">
                                                                <Card
                                                                    titulo="ENTREGADOS"
                                                                    total="78.20%" />
                                                            </div>
                                                            <div className="col-md-3">
                                                                <Card titulo="RECIBIDOS"
                                                                    total="10.10%" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <Link to="/servidores" className="btn btn-secondary">Volver</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default SimDetail;


// WEBPACK FOOTER //
// ./src/components/sim/SimDetail.js